import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const CityContext = createContext();

export const useCity = () => {
  const context = useContext(CityContext);
  if (!context) {
    throw new Error('useCity must be used within a CityProvider');
  }
  return context;
};

export const CityProvider = ({ children }) => {
  const [currentCity, setCurrentCity] = useState(api.getCurrentCity());
  const [cities, setCities] = useState([]);

  const refreshCities = useCallback(async () => {
    try {
      const result = await api.getCities();
      setCities(result.cities || []);
    } catch (error) {
      console.error('Не удалось загрузить список городов:', error);
    }
  }, []);

  useEffect(() => {
    refreshCities();
  }, [refreshCities]);

  const changeCity = (city) => {
    if (cities.some((c) => c.id === city)) {
      setCurrentCity(city);
      localStorage.setItem("currentCity", city);
      api.setCurrentCity(city); // ✅ Обновляем город в API-клиенте
    }
  };

  const currentCityInfo = cities.find((c) => c.id === currentCity);

  const value = {
    currentCity,
    changeCity,
    cities,
    refreshCities,
    cityName: currentCityInfo?.displayName || currentCity,
  };

  return (
    <CityContext.Provider value={value}>
      {children}
    </CityContext.Provider>
  );
};
